import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { fetchSixDetailMetaAndFilesThunk } from '@/store/thunks/sixDetail/fetchMetaAndFilesThunk';
import { publishSixEventThunk, createFolderDeletedEvent } from '@/store/thunks/poc/messaging/publishSixEventThunk';

export const deleteFolderThunk = createAppAsyncThunk<
  undefined,
  { sixId: string; id: string; folderPath: string }
>(
  'sixDetail/deleteFolder',
  withLoader(
    async({ sixId, id, folderPath }, { extra, dispatch }) => {
      await extra.sixDetailService.deleteFolder(sixId, folderPath);
      await dispatch(fetchSixDetailMetaAndFilesThunk(sixId));
      await dispatch(
        publishSixEventThunk(createFolderDeletedEvent({ sixId, id }))
      );
      return undefined;
    }
  )
);
